import { render, staticRenderFns } from "./record_detail.vue?vue&type=template&id=3359a45c&scoped=true"
import script from "./record_detail.vue?vue&type=script&lang=js"
export * from "./record_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3359a45c",
  null
  
)

export default component.exports